import React from 'react';
import { MemoryRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Header } from '@/features/header/pages/Header';
import { useAppLanguage } from '@/core/hooks/useAppLanguage';
import { SearchResult } from '@/features/header/components/TopBar/SearchDropdown';

interface HeaderAppProps {
  userData?: string | {
    userId: string;
    username: string;
    initials: string;
    avatar: string;
  };
  reprocessingStatus?: string;
  availableItems?: SearchResult[];
  filterLabels?: string[];
  hideTopBar?: boolean;
  hideFilterBar?: boolean;
  hideLanguageSelector?: boolean;
  hideSearchBar?: boolean;
  hideReprocessingStatus?: boolean;
  hideSidebarButton?: boolean;
  hideCopyFilterIdButton?: boolean;
  hideClearFilterButton?: boolean;
  showGlobalFilter?: boolean;
  lockRefreshInterval?: boolean;
  excludedChannelKeys?: string[];
}

export const HeaderApp: React.FC<HeaderAppProps> = ({
  userData,
  reprocessingStatus,
  availableItems = [],
  filterLabels = [],
  hideTopBar = false,
  hideFilterBar = false,
  hideLanguageSelector = false,
  hideSearchBar = false,
  hideReprocessingStatus = false,
  hideSidebarButton = false,
  hideCopyFilterIdButton = false,
  hideClearFilterButton = false,
  showGlobalFilter = false,
  lockRefreshInterval = false,
  excludedChannelKeys = [] as string[],
}) => {
  useAppLanguage({ forceDefault: hideLanguageSelector });

  return (
    <MemoryRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Header
              userData={userData}
              reprocessingStatus={reprocessingStatus}
              availableItems={availableItems}
              filterLabels={filterLabels}
              hideTopBar={hideTopBar}
              hideFilterBar={hideFilterBar}
              hideLanguageSelector={hideLanguageSelector}
              hideSearchBar={hideSearchBar}
              hideReprocessingStatus={hideReprocessingStatus}
              hideSidebarButton={hideSidebarButton}
              hideCopyFilterIdButton={hideCopyFilterIdButton}
              hideClearFilterButton={hideClearFilterButton}
              showGlobalFilter={showGlobalFilter}
              lockRefreshInterval={lockRefreshInterval}
              excludedChannelKeys={excludedChannelKeys}
            />
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </MemoryRouter>
  );
};
